import React, { Component } from "react";
import PieChart from "./TrafficByDeviceCard";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";
import DonutIcon from "@material-ui/icons/DonutLarge";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import * as api from "core-module/services/api";

export default class TrafficByDeviceContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: props.userId,
      labels: [],
      upData: [],
      downData: [],
      timePeriod: "30days",
      bandwidth: {},
      macAddresses: [],
      aliasNames: [],
      tooltipOpen: false,
    };
    this.onChangeRadio = this.onChangeRadio.bind(this);
    this.getLabel = this.getLabel.bind(this);
  }

  getLabel(device) {
    if (device.alias !== "") {
      return device.alias;
    } else {
      if (device.vendor === "unknown" || device.vendor === "") {
        return device.mac.match(/.{2}/g).join(":") || "";
      } else {
        return device.vendor;
      }
    }
  }

  async filterBelowTopTen(devices, timePeriod) {
    await devices?.sort((a, b) => {
      return (
        b.bandwidth[timePeriod].up +
        b.bandwidth[timePeriod].down -
        (a.bandwidth[timePeriod].up + a.bandwidth[timePeriod].down)
      );
    });
    if (devices.length > 10) {
      devices = devices.slice(0, 10);
    }
    this.setState({
      ...this.state,
      labels: devices.map((device) => this.getLabel(device)),
      upData: devices.map((device) => device.bandwidth[timePeriod].up),
      downData: devices.map((device) => device.bandwidth[timePeriod].down),
      bandwidth: devices.map((device) => device.bandwidth),
      macAddresses: devices.map((device) => device.mac),
      aliasNames: devices.map((device) => device.alias),
    });
  }

  componentDidMount() {
    api
      .get(`user.${this.state.userId}/wifiDeviceInfo`)
      .then((res) =>
        this.filterBelowTopTen(res?.list || [], this.state.timePeriod)
      );

    try {
      if (window.localStorage.getItem("editnamesTooltip") == null) {
        this.setState({ tooltipOpen: true });
      }
    } catch (e) {
      console.log(e.message);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.state.timePeriod !== nextState.timePeriod ||
      this.state.upData !== nextState.upData ||
      this.state.downData !== nextState.downData
    );
  }

  componentDidUpdate() {
    api
      .get(`user.${this.state.userId}/wifiDeviceInfo`)
      .then((res) =>
        this.filterBelowTopTen(res?.list || [], this.state.timePeriod)
      );
  }

  onChangeRadio(event) {
    const targetVal = event.currentTarget.value;
    var upData = this.state.bandwidth.map((item) =>
      item[targetVal].up ? item[targetVal].up : 0
    );
    var downData = this.state.bandwidth.map((item) =>
      item[targetVal].down ? item[targetVal].down : 0
    );
    this.setState({
      ...this.state,
      timePeriod: targetVal,
      upData: upData,
      downData: downData,
    });
  }

  render() {
    const {
      userId,
      labels,
      upData,
      downData,
      macAddresses,
      aliasNames,
    } = this.state;
    return (
      <>
        <Card style={{ backgroundColor: "#43464b" }}>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <DonutIcon />
            </CardIcon>
            <h4>WiFi Traffic by Device</h4>
          </CardHeader>
          <CardBody style={{ paddingRight: "0px", paddingLeft: "0px" }}>
            <div style={{ textAlign: "center" }}>
              <FormControlLabel
                control={
                  <Radio
                    checked={this.state.timePeriod === "30days"}
                    onChange={this.onChangeRadio}
                    value="30days"
                    color="primary"
                  />
                }
                label="Last 30 days"
                labelPlacement="end"
                style={{ color: "white" }}
              />
              <FormControlLabel
                control={
                  <Radio
                    checked={this.state.timePeriod === "1day"}
                    onChange={this.onChangeRadio}
                    value="1day"
                    color="primary"
                  />
                }
                label="Last 24 hours"
                labelPlacement="end"
                style={{ color: "white" }}
              />
            </div>
            <GridContainer align="center">
              <GridItem xs={12}>
                <div
                  style={{ backgroundColor: "#43464b", paddingRight: "0px" }}
                >
                  {labels.length > 0 && (
                    <PieChart
                      timePeriod={this.state.timePeriod}
                      tooltipOpen={this.state.tooltipOpen}
                      user={userId}
                      macAddresses={macAddresses}
                      aliasNames={aliasNames}
                      labels={labels}
                      upData={upData}
                      downData={downData}
                    />
                  )}
                </div>
              </GridItem>
              <GridItem xs={12}>
                <div style={{ color: "white" }}>
                  {labels.length > 0 && (
                    <p>
                      Note: This chart only includes wireless devices on your
                      network and does not include devices wired directly to
                      your router via ethernet cable.
                    </p>
                  )}
                </div>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </>
    );
  }
}
